import React, { Component } from 'react';
import './Main.css';
import Table from 'react-bootstrap/Table';
import { to_d } from '../helpers';

export default class SummaryAutoRace extends Component {
  render() {
    if (!this.props.target)
      return "";

    return (
      <span>
        <Table striped bordered hover variant="dark">
          <tbody>
            <tr>
              <td className="GridData2" ><div className="Unit2">Time</div><span className="summary">  {to_d(this.props.target.duration_seconds)}</span></td>
              <td className="GridData2" ><div className="Unit2">Distance</div><span className="summary"> {this.props.target.distance}</span><span className="Unit2">m</span></td>
            </tr>
            <tr>
              <td className="GridData2" ><div className="Unit2">max SPD</div><span className="summary"> {this.props.target.max_speed}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">ave SPD</div><span className="summary">  {this.props.target.ave_speed}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
            </tr>
          </tbody>
        </Table>
      </span>
    );
  }
}
